<template>
    <div class="content">
    <div class="container-fluid">
      <router-link
        :to="{ path: '/admin/boutiques/createSavePoint' }"
        class="btn btn-round my-3 border-0"
        style="background-color: #ffab0e; color: #fff"
        type="button"
        uk-toggle="target: #create_commande"
      >
        <i class="fa fa-plus"></i>Créer une commande Express
      </router-link>
      <!-- <autocomplete :search="search" placeholder="Rechercher une commande" aria-label="Choisir une commande" :get-result-value="getResultValue"></autocomplete> -->
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="uk-flex uk-flex-between uk-align-center">
                <h4 class="card-title" style="font-weight: bold">
                  Gestion des colis
                </h4>
              </div>
            </template>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="title-tab">#</th>
                  <th scope="col" class="tilte-tab">Nature de colis</th>
                  <th scope="col" class="tilte-tab">Nom du client</th>
                  <th scope="col" class="tilte-tab">Contact Destinataire</th>
                  <th scope="col" class="tilte-tab">Statut</th>
                  <th scope="col" class="tilte-tab">Valeur colis</th>
                  <th scope="col" class="tilte-tab">Nature du colis</th>
                  <th scope="col" class="tilte-tab">Date et heure</th>
                  <th scope="col" class="tilte-tab">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(test, itemObjKey) in tests"
                  :key="test.id == 'tyyt'"
                  class="livraison" uk-scrollspy="target: > td; cls:  uk-animation-slide-bottom-small; delay: 150"
                >
                  <td>{{ itemObjKey + 1 }}</td>
                  <td>{{ test.client_name }}</td>
                  <td>{{ test.client_phone }}</td>
                  <td>{{ test.dest_contact }}</td>
                  <td>{{ test.valeur }} F</td>
                  <td>{{ test.montant }} F</td>
                  <td>{{ test.nature }}</td>
                  <td>
                    {{test.created_at | moment('DD/MM/YYYY HH:mm')}}
                  </td>
                  <td>
                    <router-link
                      :to="{ path: '/Voir_livraisons/' + test.id }"
                      v-bind:tooltip="test.id"
                      class="btn btn-primary mr-2 uk-box-shadow-large">
                      <span class="" style="color: #5f5f5f" uk-icon="icon:expand; ratio: 1"></span>
                    </router-link>

                    <router-link
                      :to="{ path: '/EditLivraison/' + test.id }"
                      v-bind:tooltip="test.id"
                      class="btn btn-danger mr-2 uk-box-shadow-large" >
                      <span class="" style="color: green red" uk-icon="icon:pencil; ratio: 1"></span>
                    </router-link>

                    <button v-if="(role = '2')" @click="removeTests(test.id)" class="btn btn-default uk-box-shadow-large">
                      <span class="" style="color: #5f5f5f" uk-icon="icon:trash; ratio: 1" ></span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { db, dbstore, auth } from '../../main';
import Swal from "sweetalert2";
export default {
    data() { 
        return {
            tests: [],
            test: {
                client_name: "",
                created_at:"",
                dest_address:"",
                dest_contact:"",
                valeur: "",
                nature:"",
                status:"",
            },
            activeItem:null,
            access : 0
    }},
    created () {
        let refSotre
        refSotre = dbstore.collection('tests')
        refSotre.onSnapshot((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            this.tests.push({
                key: doc.id,
                client_name: doc.data().client_name,
                dest_address: doc.data().dest_address,
                dest_contact: doc.data().dest_contact,
                valeur: doc.data().valeur,
                nature: doc.data().nature,
                status: doc.data().status,
                created_at: doc.data().created_at,
            });
        });

        });

        // created for updateboutique
        var dbstoreRef = dbstore.collection('tests').doc(this.$route.params.uuid);
            dbstoreRef
            .get()
            .then((childSnapshot) => {
                const onData = childSnapshot.val();
                this.test = onData;
            })
            .catch(() => {
                console.log(dbstoreRef);
            });

    },
}
</script>
<style>
.tilte-tab {
  color: #000000 !important;
  font-weight: bold !important;
  font-size: 0.9em !important;
  font-family: "Poppins", sans-serif !important;
}
.livraison {
  font-weight: bold !important;
}
td {
  font-family: "Poppins", sans-serif !important;
  font-size: 0.9em !important;
}
.btn-primary {
  margin-right: 12px;
}
.dateToday {
  padding: 10px;
  border-radius: 20px;
  color: #ffffff !important;
}
.uk-form-width-small {
  background-color: #5dd381 !important;
  color: #ffffff !important;
  font-weight: bold !important;
  font-size: 0.9em !important;
  outline: none;
  border-radius: 10px;
  border: none;
}
.uk-label {
  font-size: 0.9em !important;
  font-weight: bold !important;
}
.uk-label:hover {
  background-color: #1f5cdf !important;
}
.uk-label:active {
  background-color: #0c307e !important;
}
</style>

